<template>
  <div class="">
    <div class="flex mb-4 mt-3">
      <div :key="card.id" v-for="(card, index) in content" :class="'w-'+card"
           class=" flex-1 p-2 m-2 bg-gray-400 text-center">
        <div class="mb-3 font-bold">
          Select dashboard to display
        </div>
        <label :key="dash_index" class="flex justify-start items-start" v-for="(dashboard, dash_index) in dashboards">
          <div
              class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500"
              v-on:click="card.dashlet = dash_index">
            <input type="radio" :value="dash_index" :name="index + '_dashlet'" class="opacity-0 absolute">
            <svg class="fill-current hidden w-4 h-4 text-green-500 pointer-events-none" viewBox="0 0 20 20">
              <path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/>
            </svg>
          </div>
          <div class="select-none">{{ dashboard }}</div>
        </label>
      </div>
    </div>
    <div class="flex justify-end">
      <button type="submit" v-on:click="addRow()" class="rounded px-4 md:px-5 xl:px-2 py-1  bg-teal-500 hover:bg-teal-600 leading-tight
                       xl:text-base text-white">
        Add
      </button>
    </div>
  </div>
</template>

<script>

import {v4 as uuidv4} from 'uuid';

export default {
  name: "SelectDashboard",
  props: {
    layout: Array
  },
  data() {
    return {
      dashboards: {
        org_overview: "Organization overview",
        online_connections: "Who is online",
        connection_summary: "Recent connections",
        top_sites: "Top Hotspots",
        ap_status: "Top Access point",
        auth_mode_summary: "Auth Mode Summary",
        is_mobile_summary: "Device Type Summary",
        os_summary: "Operating System Summary",
        brand_summary: "Device Brand Summary",
        browser_summary: "Browser Summary",
        campaign_summary: "Campaign Summary",
        dwell_time: "Dwell time",
        footfall: "Foot fall",
        connection_graph: "Connections trend",
        heatmap: "Heatmap",
      },
      content: [], 
      row: {}
    }
  },
  mounted() {
    this.layout.forEach(section => {
      this.content.push({
        id: uuidv4(),
        width: 'w-' + section,
        type: 'dashlet',
        dashlet: null
      })
    })
  },
  methods: {
    addRow() {
      this.$root.$emit('add_dashlet', {
        id: uuidv4(),
        type: 'row',
        content: this.content
      })
    }
  }
}
</script>

<style scoped>
input:checked + svg {
  display: block;
}
</style>